import { AxiosResponse } from 'axios';
import { RemunerationDto } from '../../Model/Dto/EmploymentEquity/Remuneration';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.EEA4';

export const EEA4Service = {
  GetTotalRemuneration: (
    scorecardId: string
  ): Promise<AxiosResponse<RemunerationDto.SummaryRowDto[]>> =>
    axiosCoreInstance.get(
      `${ApiUrls.GetTotalRemuneration}?scorecardId=${scorecardId}`
    ),

  GetRemunerationDetail: (
    scorecardId: string,
    isTopRemuneration: boolean
  ): Promise<AxiosResponse<RemunerationDto.SummaryRowDto[]>> =>
    axiosCoreInstance.get(
      `${ApiUrls.GetRemuneration}?scorecardId=${scorecardId}&isTopRemuneration=${isTopRemuneration}`
    ),

  SearchTotalRemunerationIndividuals: (
    searchRequest: RemunerationDto.IndividualsSearchRequest
  ): Promise<AxiosResponse<RemunerationDto.IndividualsSearchResponse>> =>
    axiosCoreInstance.post(
      `${ApiUrls.GetTotalRemunerationIndividuals}`,
      searchRequest
    ),

  SearchRemunerationIndividuals: (
    searchRequest: RemunerationDto.IndividualsSearchRequest
  ): Promise<AxiosResponse<RemunerationDto.IndividualsSearchResponse>> =>
    axiosCoreInstance.post(
      `${ApiUrls.GetRemunerationIndividuals}`,
      searchRequest
    ),
};
